import { Children, cloneElement, FC, PropsWithChildren, ReactElement } from 'react';

import { isElement } from 'react-is';

import { stretchRecipe } from './Stretch.css';
import { RecipeVariants } from '../../vanilla-extract.css';

type Props = RecipeVariants<typeof stretchRecipe>;

export const Stretch: FC<PropsWithChildren<Props>> = ({ children, width, height }) => {
  const stretchClassNames = stretchRecipe({ width, height });

  const arrayChildren = Children.toArray(children);
  const stretchedChildren = Children.map(arrayChildren, child => {
    if (isElement(child)) {
      return cloneElement(child as ReactElement<{ className: string }>, {
        className: stretchClassNames,
      });
    }

    return <div className={stretchClassNames}>{child}</div>;
  });

  /**
   * Because of a TS issue (https://github.com/DefinitelyTyped/DefinitelyTyped/issues/20356), we need to wrap the children in a fragment.
   * ESlint doesn't like this. But we do.
   */

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{stretchedChildren}</>;
};

Stretch.displayName = 'Stretch';
